import { useMutation } from '@tanstack/react-query';
import { openAccountInvest } from '../requests';
import type { OpenAccountResponseDto } from '../types';

interface UseOpenAccountInvestOptions {
  onSuccess?: (data: OpenAccountResponseDto) => void;
}

const useOpenAccountInvest = (options?: UseOpenAccountInvestOptions) => {
  const mutation = useMutation({
    mutationFn: openAccountInvest,
    onSuccess: options?.onSuccess,
  });

  return {
    openAccount: mutation.mutateAsync,
    isOpenAccountPending: mutation.isPending,
    isOpenAccountSuccess: mutation.isSuccess,
    isOpenAccountError: mutation.isError,
    openAccountData: mutation.data,
    openAccountError: mutation.error,
  };
};

export { useOpenAccountInvest };
